import { PTOItem } from "../../../models/PtoRecord";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import React, { useState } from "react";
import { Dialog } from "primereact/dialog";
import { formatDate } from "../../../utils/DateUtils";

function PtoTopics({ ptoTopics }: { ptoTopics?: PTOItem[] | null }) {
  const [selectedTopic, setSelectedTopic] = useState<PTOItem | null>(null);

  const createdAtBody = (data: PTOItem) => {
    return <span>{data.created_at ? formatDate(data.created_at) : "—"}</span>;
  };

  const updatedAtBody = (data: PTOItem) => {
    return <span>{data.updated_at ? formatDate(data.updated_at) : "—"}</span>;
  };

  if (!ptoTopics) {
    return <></>;
  }

  return (
    <div>
      <DataTable
        value={ptoTopics ?? []}
        tableStyle={{ minWidth: "50rem" }}
        onRowClick={val => {
          setSelectedTopic(val.data as PTOItem);
        }}
        selectionMode="single"
      >
        <Column field={"name"} header={"Name"} />
        <Column field={"created_at"} header={"Created at"} body={updatedAtBody} />
        <Column field={"updated_at"} header={"Updated at"} body={createdAtBody} />
      </DataTable>
      {selectedTopic && (
        <Dialog
          onHide={() => setSelectedTopic(null)}
          visible={!!selectedTopic}
          header={selectedTopic?.name}
          style={{ width: "50vw" }}
        >
          <div className={"my-4"}>
            <div className={"key-value"}>
              <label className={"font-bold mr-4"}>Created at:</label>
              <span>{formatDate(selectedTopic?.created_at)}</span>
            </div>
            <div className={"key-value"}>
              <label className={"font-bold mr-4"}>Updated at:</label>
              <span>{formatDate(selectedTopic?.updated_at)}</span>
            </div>
            <div dangerouslySetInnerHTML={{ __html: selectedTopic?.body }} />
          </div>
        </Dialog>
      )}
    </div>
  );
}

export { PtoTopics };
